const BhMetricVolume = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx={10} cy={10} r={7.292} stroke="currentColor" strokeWidth={1.5} />
    <path
      d="M10 5.833v8.334M12.083 7.708c0-.92-.933-1.666-2.083-1.666s-2.083.746-2.083 1.666c0 .92.933 1.459 2.083 1.459s2.083.746 2.083 1.667-.933 1.666-2.083 1.666-2.083-.746-2.083-1.666"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default BhMetricVolume
